export enum DashboardGraphType {
    bar = 100,
    pie = 200,
    column = 300,
}

// The string values are i18n keys resolved via the `transloco` pipe at the display site
export const DashboardGraphTypeDescription: { [type in DashboardGraphType]: string } = {
    100: "dashboard.graphType.bar",
    200: "dashboard.graphType.pie",
    300: "dashboard.graphType.column",
};

export const DashboardGraphTypeHighchartMapping: { [type in DashboardGraphType]: string } = {
    100: "bar",
    200: "pie",
    300: "column",
};
